import React from 'react';

import Layout from '../components/layout';
import './privacy.css';
import SEO from '../components/seo';


const SecondPage = () => (
  <Layout caller='privacy'>
    <SEO title="Privacy Policy"/>
    <div className="entry-content">
      <h1>Condizioni accettazione modulo mail</h1>
      <div id="wpcf7-f280-p278-o1" className="wpcf7" dir="ltr" lang="it-IT">
        <form
          className="wpcf7-form"
          action="http://www.pugliafolklore.it/contatti-2/#wpcf7-f280-p278-o1"
          method="post"
          noValidate="novalidate"
        >
          <div>
            <p>
              <strong>PRIVACY TRATTAMENTO DEI DATI PERSONALI</strong>
              <br /> (Privacy policy ai sensi dell&rsquo;art. 13 del d.lgs.
              196/2003)
            </p>
            <p>
              Noi di{' '}
              <strong>
                <span id="sito">http://www.estetica-orchidea.it</span>
              </strong>{' '}
              riteniamo che la privacy dei nostri visitatori sia estremamente
              importante. Questo documento descrive dettagliatamente i tipi di
              informazioni personali raccolti e registrati dal nostro sito e
              come essi vengano utilizzati.
              <br /> La informiamo che i dati che fornir&agrave; al gestore del
              presente sito al momento della compilazione del &ldquo;form
              contatti&rdquo; (detto anche form mail) del sito stesso, saranno
              trattati nel rispetto delle disposizioni di cui al d.lgs.
              196/2003, Codice in materia di protezione dei dati personali.
              <br /> Il form contatti messo a disposizione sul sito ha il solo
              scopo di consentire ai visitatori del sito di contattare, qualora
              lo desiderino, il gestore del sito stesso, inviando tramite il
              suddetto form una email al gestore.
              <br /> La presente informativa riguarda i dati personali inviati
              dall&rsquo;utente visitatore al momento della compilazione del
              form contatti.
              <br /> La informiamo del fatto che i dati che conferir&agrave;
              volontariamente tramite il form verranno tramutati in una email
              che eventualmente potr&agrave; essere conservata all&rsquo;interno
              del sistema di ricezione di email utilizzato dal titolare del
              sito.
              <br /> Questi dati non verranno registrati su altri supporti o
              dispositivi, n&egrave; verranno registrati altri dati derivanti
              dalla sua navigazione sul sito.
            </p>
            <p>
              <br />{' '}
              <strong>
                1. FINALIT&Agrave; DEL TRATTAMENTO DEI DATI PERSONALI
              </strong>
              <br /> Le finalit&agrave; del trattamento dei suoi dati sono le
              seguenti:
              <br /> I dati da lei inviati verranno utilizzati al solo scopo di
              poterla eventualmente ricontattare tramite i riferimenti da lei
              lasciati tramite il form contatti per evadere eventuali sue
              richieste contenute nel messaggio da lei inviato tramite il form
              contatti messo a disposizione sul sito.
            </p>
            <p>
              <br />{' '}
              <strong>
                2. NATURA DEI DATI TRATTATI E MODALIT&Agrave; DEL TRATTAMENTO
              </strong>
            </p>
            <ol>
              <li>
                I dati personali trattati saranno esclusivamente i dati comuni
                strettamente necessari e pertinenti alle finalit&agrave; di cui
                al punto 1 che precede.
              </li>
              <li>
                Il trattamento dei dati personali conferiti &egrave; realizzato
                per mezzo delle operazioni o del complesso delle operazioni
                indicate all&rsquo;art. 4 comma 1 lett. a) D. Lgs. 196/2003.
              </li>
              <li>
                Il trattamento &egrave; svolto direttamente
                dall&rsquo;organizzazione del titolare.
              </li>
            </ol>
            <p>
              <br />{' '}
              <strong>
                3. NATURA DEL CONFERIMENTO E CONSEGUENZE DEL RIFIUTO
              </strong>
              <br /> Non vi &eacute; alcun obbligato a conferire al gestore del
              presente sito i dati personali richiesti nel form contatti.
              <br /> Il conferimento dei dati tramite form contatti &egrave;
              facoltativo.
              <br /> Tuttavia il rifiuto al conferimento per le finalit&agrave;
              di cui all&rsquo;art. 1 determiner&agrave;
              l&rsquo;impossibilit&agrave; di contattare il gestore del sito web
              tramite il form contatti messo a disposizione sul sito.
            </p>
            <p>
              <br /> <strong>4. TITOLARE DEL TRATTAMENTO</strong>
              <br /> I dati personali raccolti mediante il form contatti saranno
              inviati via email al gestore del presente sito web, che
              sar&agrave; titolare del trattamento.
              <br />
              Vi segnaliamo che il titolare del trattamento ad ogni effetto di
              legge &egrave;:
            </p>
            <ul>
              <li>
                <strong>
                  <span id="azienda">Cristoforetti Anita</span>
                </strong>
              </li>
              <li>
                P. IVA <span id="iva">01986620225</span>
              </li>
              <li>
                Codice Fiscale:{' '}
                <span id="codice_Fiscale">CRSNTA85R50H612X</span>
              </li>
              <li>
                <span id="indirizzo">Via Degasperi, 26</span>
              </li>
              <li>
                <span id="cap">38063</span> - <span id="citta">Avio</span> (
                <span id="provincia">TN</span>)
              </li>
              <li>
                Tel/Fax: <span id="telefono">0464 683157</span>
              </li>
              <li>
                E-mail:{' '}
                <span id="email">
                  <a href="mailto:anitac85@hotmail.it">anitac85@hotmail.it</a>
                </span>
              </li>
            </ul>
            <h3>
              <br />
              5.Diritti dell'interessato
            </h3>
            <p>
              Ai sensi ai sensi dell'art. 7 (Diritto di accesso ai dati
              personali ed altri diritti) del Codice della Privacy, vi
              segnaliamo che i vostri diritti in ordine al trattamento dei dati
              sono:
            </p>
            <ul>
              <li>
                conoscere, mediante accesso gratuito l'esistenza di trattamenti
                di dati che possano riguardarvi;
              </li>
              <li>
                essere informati sulla natura e sulle finalit&agrave; del
                trattamento
              </li>
              <li>ottenere a cura del titolare, senza ritardo:</li>
              <ul>
                <li>
                  la conferma dell'esistenza o meno di dati personali che vi
                  riguardano, anche se non ancora registrati, e la comunicazione
                  in forma intellegibile dei medesimi dati e della loro origine,
                  nonch&eacute; della logica e delle finalit&agrave; su cui si
                  basa il trattamento; la richiesta pu&ograve; essere rinnovata,
                  salva l'esistenza di giustificati motivi, con intervallo non
                  minore di novanta giorni;
                </li>
                <li>
                  la cancellazione, la trasformazione in forma anonima o il
                  blocco dei dati trattati in violazione di legge, compresi
                  quelli di cui non &egrave; necessaria la conservazione in
                  relazione agli scopi per i quali i dati sono stati raccolti o
                  successivamente trattati;
                </li>
                <li>
                  l'aggiornamento, la rettifica ovvero, qualora vi abbia
                  interesse, l'integrazione dei dati esistenti;
                </li>
                <li>
                  opporvi in tutto o in parte per motivi legittimi al
                  trattamento dei dati personali che vi riguardano
                  ancorch&eacute; pertinenti allo scopo della raccolta;
                </li>
              </ul>
            </ul>
            <p>
              Per esercitare i diritti previsti all'art. 7 del Codice della
              Privacy ovvero per la cancellazione dei vostri dati dall'archivio,
              &egrave; sufficiente contattarci attraverso uno dei canali messi a
              disposizione. Tutti i dati sono protetti attraverso l'uso di
              antivirus, firewall e protezione attraverso password.
            </p>
            <p>
              <br /> <strong>6. DURATA DEL TRATTAMENTO</strong>
              <br /> Il trattamento avr&agrave; una durata non superiore a
              quella necessaria alle finalit&agrave; per le quali i dati sono
              stati raccolti.
            </p>
          </div>
        </form>
      </div>
    </div>
  </Layout>
)

export default SecondPage
